module.exports = __webpack_public_path__ + "img/EOs-with-the-Pros.f8837dde.png";